<template>
  <b-container>
    <b-row align-h="center" class="mt-5">
      <b-col cols="12">
        <b-card-header class="card-main-header">
          <h3 class="text-center">Editing</h3>
        </b-card-header>
        <b-card class="card-main p-3 text-center">

          <img class="rounded-circle" :src="user.avatar_url" width="32" height="32">
          <h4 class="text-center pb-3 font-weight-light">{{ user.username }}</h4>

          <hr>

          <b-row>
            <b-col sm="4">
              <h6 class="pb-5">Expiry: {{ expirationDate }}</h6>
            </b-col>
            <b-col sm="4">
              <h6 class="pb-5">Rank: {{ !user.plan ? 'None' :  user.plan.name }}</h6>
            </b-col>
            <b-col sm="4">
              <h6 class="pb-5">SteamID: {{ user.steam_id }}</h6>
            </b-col>
          </b-row>

          <b-row class="mb-3">
            <b-col sm="2">
              <label for="input-username">Username:</label>
            </b-col>
            <b-col sm="4">
              <b-form-input v-model="user.username" class="input-dark" id="input-username" size="sm"></b-form-input>
            </b-col>
            <template v-if="!user.permanent">
            <b-col sm="2">
              <label for="input-expiration">Expiration Date:</label>
            </b-col>
            <b-col sm="4">
              <b-form-datepicker v-model="user.expiration_date" local="en" class="input-dark" id="input-expiration" size="sm" type="date"></b-form-datepicker>
            </b-col>
            </template>
          </b-row>

          <b-row class="mb-3">
            <b-col sm="2">
              <label for="input-discord">DiscordID:</label>
            </b-col>
            <b-col sm="4">
              <b-form-input v-model="user.discord_id" class="input-dark" id="input-discord" size="sm"></b-form-input>
            </b-col>
            <b-col sm="2">
              <label for="input-permanent">Is Permanent:</label>
            </b-col>
            <b-col sm="1">
              <b-form-checkbox id="input-permanent" v-model="user.permanent"></b-form-checkbox>
            </b-col>
            <template v-if="!isDonatorInactive">
            <b-col sm="2">
              <label for="input-removal">Force Removal:</label>
            </b-col>
            <b-col sm="1">
              <b-form-checkbox id="input-removal" v-model="user.remove"></b-form-checkbox>
            </b-col>
            </template>
          </b-row>

          <b-row class="mb-5">
            <b-col sm="2">
              <label for="input-rank">Rank:</label>
            </b-col>
            <b-col sm="4">
              <b-dropdown class="input-dark" :text="!user.plan ? 'None' : user.plan.name" v-model="user.plan">
                <b-dropdown-item v-for="plan in plans" @click="user.plan = plan" :key="plan.id">
                  {{ plan.name }}
                </b-dropdown-item>
              </b-dropdown>
            </b-col>
          </b-row>

          <button class="btn btn-md btn-primary float-right" v-on:click="updateUser">
            Save
          </button>

          <a href="/admin" class="btn btn-md btn-secondary float-left">
            Back
          </a>

        </b-card>
      </b-col>
    </b-row>
    <b-row align-h="center" class="mt-5">
      <b-col cols="12">
        <b-card-header class="card-main-header">
          <h3 class="text-center">Donations by {{ user.username }}</h3>
        </b-card-header>
        <b-card class="card-main p-3 text-center">

          <DonationsTable :user="user"></DonationsTable>

        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import moment from "moment";
import UserApi from "@/services/UserApi";
import PlanApi from "@/services/PlanApi";
import EventBus from "@/services/EventBus";

const DonationsTable = () => import(
  '../../Tables/Donations.vue'
);

export default {
  async created() {
    UserApi.getUser(this.$route.params.id)
      .then(user => {
        this.user = user;
      })
      .catch(error => {
        EventBus.$emit('Error', error);
      });

    PlanApi.getPlans()
      .then(plans => {
        this.plans = plans;
      })
      .catch(error => {
        EventBus.$emit('Error', error);
      });
  },
  data() {
    return {
      plans: [],
      user: []
    };
  },
  computed: {
    expirationDate() {
      if(this.user.expiration_date == null && !this.user.permanent) {
        return 'None';
      } if(this.user.permanent) {
        return 'Permanent';
      } else {
        return moment(this.user.expiration_date).fromNow();
      }
    },
    isDonatorInactive() {
      if ((this.user.expiration_date == null && !this.user.permanent) || this.user.plan == undefined || this.user.plan_id == 0) {
        return true;
      } else if (!this.user.permanent && moment(this.user.expiration_date).isBefore(new Date())) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    updateUser() {
      UserApi.updateUser(this.user)
      .then(res => {
        EventBus.$emit('Success', res);
      })
      .catch(error => {
        EventBus.$emit('Error', error);
      });
    }
  },
  components: {
    'DonationsTable': DonationsTable,
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Admin/User/Edit.vue